// subscriptionSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  FETCH_SUBSCRIPTION_START,
  FETCH_SUBSCRIPTION_SUCCESS,
  FETCH_SUBSCRIPTION_FAILURE,
  SET_DEFAULT_PAYMENT_METHOD,
} from "state/types/actionTypes";

const initialState = {
  data: null,
  loading: false,
  error: null,
  loaded: false,
  defaultPaymentMethod: null,
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(FETCH_SUBSCRIPTION_START, (state) => {
        state.loading = true;
        state.error = null;
        state.loaded = false;
      })
      .addCase(FETCH_SUBSCRIPTION_SUCCESS, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.loaded = true;
      })
      .addCase(FETCH_SUBSCRIPTION_FAILURE, (state, action) => {
        state.error = action.payload;
        state.loading = false;
        state.loaded = true;
      })
      .addCase(SET_DEFAULT_PAYMENT_METHOD, (state, action) => {
        state.defaultPaymentMethod = action.payload;
      });
  },
});

export const subscriptionReducer = subscriptionSlice.reducer;
